import { render } from "./AlSalads.vue?vue&type=template&id=c70fa802&scoped=true"
import script from "./AlSalads.vue?vue&type=script&lang=js"
export * from "./AlSalads.vue?vue&type=script&lang=js"

import "./AlSalads.vue?vue&type=style&index=0&id=c70fa802&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70fa802"]])

export default __exports__